import Image from 'components/Shared/Image';
import styles from './index.module.css';
import {useEffect, useRef} from 'react';

const images = ['/assets/images/home/ad-01-670x492.png', '/assets/images/home/ad-02-670x492.png'];
const SlideShow = () => {
  const slideRef = useRef([]);
  let slideIndex = 0;

  const showSlides = () => {
    for (let i = 0; i < slideRef.current.length; i++) {
      slideRef.current[i].style.display = 'none';
    }
    slideIndex++;

    if (slideIndex > slideRef.current.length) {
      slideIndex = 1;
    }

    slideRef.current[slideIndex - 1].style.display = 'block';

    return setTimeout(showSlides, 3000);
  };

  useEffect(() => {
    const intervalId = showSlides();
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="relative">
      {images.map((slide, index) => (
        <div
          className={styles.fade}
          key={index}
          ref={element => {
            slideRef.current[index] = element;
          }}>
          <div className="text-xl absolute text-white left-0 px-3 z-10">
            {index + 1} / {images.length}
          </div>
          <Image src={slide} className="" />
        </div>
      ))}
    </div>
  );
};

export default SlideShow;
